"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vf_config_manager_1 = require("./vf-config-manager");
var Logger = (function () {
    function Logger() {
    }
    Logger.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var args2 = Array.prototype.slice.call(args);
        args2.unshift(Logger.LOG_PREFIX + " ");
        console.warn.apply(console, args2);
    };
    Logger.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (vf_config_manager_1.default.enableDebug) {
            var args2 = Array.prototype.slice.call(args);
            args2.unshift(Logger.LOG_PREFIX + " ");
            console.debug.apply(console, args2);
        }
    };
    Logger.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var args2 = Array.prototype.slice.call(args);
        args2.unshift(Logger.LOG_PREFIX + " ");
        console.log.apply(console, args2);
    };
    Logger.logError = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var args2 = Array.prototype.slice.call(args);
        args2.unshift(Logger.LOG_PREFIX + " ");
        console.error.apply(console, args2);
    };
    Logger.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Logger.logError(args);
        if (this.ErrorCallback) {
            this.ErrorCallback(args.join(", "));
        }
    };
    Logger.LOG_PREFIX = "[VFPlayer]";
    return Logger;
}());
exports.default = Logger;
